const initHeroSlider = async () => {
  const heroSlider = document.querySelector('.feat-slider');

  if (!heroSlider) {
    return;
  }

  new Swiper('.feat-slider', {
    direction: 'horizontal',
    loop: true,
    slidesPerView: 1,
    spaceBetween: 0,
    parallax: true,
    speed: 1000,
    allowTouchMove: true,
    watchOverflow: true,
    on: {
      init: function () {
        heroSlider.classList.remove('hidden');

        if (this.slides.length > 1) {
          this.pagination.el.classList.remove('feat-slider-pagination--hidden');
          this.navigation.prevEl.classList.remove('feat-slider-prev-btn--hidden');
          this.navigation.nextEl.classList.remove('feat-slider-next-btn--hidden');
        }
      },
    },
    breakpoints: {
      1100: {
        allowTouchMove: false,
      },
    },
    pagination: {
      el: '.feat-slider-pagination',
      clickable: true,
      bulletClass: 'feat-slider-pagination-bullet',
      bulletActiveClass: 'active',
      renderBullet: function (_, className) {
        return `<div class="${className}"><span></span></div>`;
      },
    },
    navigation: {
      nextEl: '.feat-slider-next-btn',
      prevEl: '.feat-slider-prev-btn',
    },
  });
};

export { initHeroSlider };
